<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView && editItems != null" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <Title title="環境BOXの編集">
                <v-spacer />
                <TitleButton
                    icon="mdi-floppy"
                    name="保存"
                    @click="onClickSave()" />
                <TitleButton
                    icon="mdi-close-circle"
                    name="閉じる"
                    @click="isView = false" />
            </Title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <h2 class="mt-4 mb-2">基本設定</h2>
                    <v-row align="baseline">
                        <v-col>
                            <v-text-field
                                v-model="editItems.code"
                                dense
                                clearable
                                hide-details
                                label="BOX識別コード"
                                item-text="text"
                                outlined
                                :disabled="targetBox != null" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="editItems.name"
                                dense
                                clearable
                                hide-details
                                label="名称"
                                item-text="text"
                                outlined />
                        </v-col>
                    </v-row>
                    <template v-if="targetBox != null">
                        <h2 class="mt-4 mb-2">センサー設定</h2>
                        <v-row>
                            <v-col v-for="sensor in targetBox.master.sensors" :key="sensor.sensorKey">
                                <v-card tile class="pa-1" @click="onClickSensor(sensor)" :color="sensor.enabled ? 'light-blue lighten-5' : 'grey lighten-2'">
                                    <table style="width:100%">
                                        <tr>
                                            <td style="width:100%" colspan="2">
                                                <h3 v-if="sensor.enabled" class="black--text">{{sensor.name}}</h3>
                                                <h3 v-else class="grey--text">{{sensor.name}}(無効)</h3>
                                                <v-divider class="mt-1 mb-1" />
                                            </td>
                                        </tr>
                                        <tr class="grey--text">
                                            <td>
                                                <v-icon>{{sensorTypeIcon(sensor)}}</v-icon>
                                            </td>
                                            <td style="width:100%">
                                                <h5>{{sensorTypeName(sensor)}}</h5>
                                            </td>
                                        </tr>
                                    </table>
                                </v-card>
                                <!-- {{sensor.sensorKey}} -->
                            </v-col>
                        </v-row>
                        <v-btn class="mb-2" color="primary" text @click="onClickAddNewSensor"><v-icon>mdi-plus-circle-outline</v-icon>新しいセンサーを追加する</v-btn>
                    </template>
                    <template v-if="targetBox != null">
                        <h2 class="mt-4 mb-2">警報設定</h2>
                        <v-row>
                            <v-col cols="12">
                                <v-card>
                                    <v-card-text class="pa-0">
                                        <v-container fluid class="pt-0">
                                            <v-row dense>
                                                <v-col class="pt-0">
                                                    <v-checkbox 
                                                        v-model="editItems.aliveAlarm.enabled" 
                                                        label="生存信号警報を有効にする"
                                                        hide-details />
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <NumInput 
                                                                    v-model="editItems.aliveAlarm.durationTime" 
                                                                    outlined
                                                                    label="監視時間"
                                                                    type="text" 
                                                                    align="align-left"
                                                                    suffix="分"
                                                                    hide-details 
                                                                    dense
                                                                    :canEdit="editItems.aliveAlarm.enabled" />
                                                            </td>
                                                            <td>以上、確認出来なかった時に警報</td>
                                                        </tr>
                                                    </table>
                                                </v-col>
                                            </v-row>
                                            <v-row dense>
                                                <v-col>
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <NumInput 
                                                                    v-model="editItems.aliveAlarm.nextAlarmInterval" 
                                                                    outlined
                                                                    label="再警報間隔"
                                                                    type="text" 
                                                                    align="align-left"
                                                                    suffix="分"
                                                                    hide-details 
                                                                    dense
                                                                    :canEdit="editItems.aliveAlarm.enabled" />
                                                            </td>
                                                            <td>後に再警報</td>
                                                        </tr>
                                                    </table>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-if="targetBox != null">
                        <h2 class="mt-4 mb-2">警報通知設定</h2>
                        <v-row>
                            <v-col cols="12">
                                <v-card >
                                    <v-card-text class="pa-0">
                                        <v-container fluid class="pt-0">
                                            <v-row >
                                                <v-col>
                                                    <v-select
                                                        v-model="editItems.notification.type"
                                                        :items="notificationTypes"
                                                        item-text="text"
                                                        item-value="type"
                                                        label="通知方法"
                                                        hide-details />
                                                </v-col>
                                            </v-row>
                                            <template v-if="editItems.notification.type == 1">
                                                <v-row>
                                                    <v-col>
                                                        <v-text-field
                                                            v-model="editItems.notification.typeTelData.tel"
                                                            dense
                                                            clearable
                                                            hide-details
                                                            label="通知先TEL番号"
                                                            item-text="text"
                                                            outlined />
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col>
                                                        <NumInput 
                                                            v-model="editItems.notification.typeTelData.callTime" 
                                                            outlined
                                                            label="呼出時間"
                                                            type="text" 
                                                            align="align-left"
                                                            suffix="秒"
                                                            hide-details 
                                                            dense />
                                                    </v-col>
                                                    <v-col>
                                                        <NumInput 
                                                            v-model="editItems.notification.typeTelData.reCallInterval" 
                                                            outlined
                                                            label="再呼出間隔"
                                                            type="text" 
                                                            align="align-left"
                                                            suffix="秒"
                                                            hide-details 
                                                            dense />
                                                    </v-col>
                                                    <v-col>
                                                        <NumInput 
                                                            v-model="editItems.notification.typeTelData.reNum" 
                                                            outlined
                                                            label="再呼出回数"
                                                            type="text" 
                                                            align="align-left"
                                                            suffix="回"
                                                            hide-details 
                                                            dense />
                                                    </v-col>
                                                </v-row>
                                            </template>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </template>
                </v-container>
            </v-card-text>
        </v-card>
        <MaintenanceSensor ref="sensorMaintenance" @onUpdatedSensor="onUpdatedSensor" />
        <Confirm ref="confirm" />
    </v-dialog>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import NumInput from '@/components/tools/SoftwareNumKeyboard'
    import MaintenanceSensor from '@/components/box/MaintenanceSensor';
    import BoxRegister from '@/components/box/RegisterBoxMaster';
    import Confirm from '@/components/tools/ConfirmDialog';
    import crypto from "crypto-js"

    export default {
        props: {
            boxes: null
        },
        components: {
            Title,
            TitleButton,
            NumInput,
            MaintenanceSensor,
            Confirm,
        },
        data: function () {
            return {
                /** ダイアログの表示状態 */
                isView: false,
                notificationTypes: [
                    {type: 1, text: "TEL"},
                    {type: 11, text: "メール"},
                ],
                /** 編集項目 */
                editItems: null,
                /** 編集対象のBOX(新規の時は null) */
                targetBox: null
            }
        },
        computed: {
            /**
             * ユーザーUID(グループユーザーの圃場参照時は、そのユーザーのUID)
             */
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            /**
             * センサーの種類の名称
             */
            sensorTypeName: function () {
                return function (sensor) {
                    switch (sensor.type) {
                        case 1:
                            return "1wire温度計"
                    }
                    return ""
                }
            },
            /**
             * センサーの種類のアイコン
             */
            sensorTypeIcon: function () {
                return function (sensor) {
                    switch (sensor.type) {
                        case 1:
                            return "mdi-home-thermometer-outline"
                    }
                    return ""
                }
            }
        },
        methods: {
            /**
             * 保存ボタン押下時
             */
            onClickSave: function () {
                const self = this
                this.$refs.confirm.show({
                    title: "登録",
                    message: "この環境BOXを登録しますか？",
                    buttonYes: "登録する",
                    buttonNo: "いいえ",
                    width: 400,
                    listenerYes: function () {
                        self.updateBox()
                        return true
                    },
                })
            },
            /**
             * 新しいセンサー追加ボタン押下時
             */
            onClickAddNewSensor: function () {
                this.$refs.sensorMaintenance.show()
            },
            /**
             * センサー押下時
             */
            onClickSensor: function (sensor) {
                this.$refs.sensorMaintenance.show(sensor)
            },
            /**
             * センサーの設定画面で設定内容が更新された時
             */
            onUpdatedSensor: function (updateInfo) {
                console.log("onUpdatedSensor", updateInfo)
                if (updateInfo.isNewSensor) {
                    this.targetBox.master.sensors.push(updateInfo.sensor)
                }

                const register = new BoxRegister.Register()
                register.Regist(this, this.targetBox.master)

                console.log("box updated!!!!!")
            },
            /**
             * 環境BOXの登録,更新処理
             */
            updateBox: function () {
                const self = this
                // 登録データ作成
                var box = this.targetBox == null ? null : this.targetBox.box
                if (box == null) {
                    box = {
                        boxIdentificationCode: this.editItems.code,
                        name: this.editItems.name,
                        registDateTime: this.df_currentDateTime()
                    }
                } else {
                    box.name = this.editItems.name
                }
                // 登録処理
                db.collection("users").doc(this.userUID).collection("boxes").doc(box.boxIdentificationCode).set(box).then(function(){
                    self.$store.commit("notification", {message:"BOXを登録しました。", isError:false})
                    if (self.targetBox == null) {
                        db.collection("environments").doc(box.boxIdentificationCode).get().then(function(docMaster) {
                            const master = docMaster.data()
                            const boxData = {
                                box: box,
                                master: master
                            }
                            self.boxes.push(boxData)
                        }).catch (function (error) {
                            self.mi_writeLog("BoxManager/created", "BOXマスターの取得に失敗しました。("+error+")")
                        })
                    } else {
                        self.targetBox.master = {
                            boxIdentificationCode: self.targetBox.master.boxIdentificationCode,
                            name: self.editItems.name,
                            userUID: self.targetBox.master.userUID,
                            sensors: self.targetBox.master.sensors,
                            aliveAlarm: {
                                enabled: self.editItems.aliveAlarm.enabled,
                                durationTime: self.editItems.aliveAlarm.durationTime * 1,
                                nextAlarmInterval: self.editItems.aliveAlarm.nextAlarmInterval * 1,
                            },
                            notification: {
                                type: null,
                                data: null
                            }
                        }
                        switch (self.editItems.notification.type) {
                            case 1:
                                self.targetBox.master.notification.type = 1
                                self.targetBox.master.notification.data = {
                                    callTime: self.editItems.notification.typeTelData.callTime * 1,
                                    reCallInterval: self.editItems.notification.typeTelData.reCallInterval * 1,
                                    reNum: self.editItems.notification.typeTelData.reNum * 1,
                                    tel: crypto.AES.encrypt(self.editItems.notification.typeTelData.tel, self.targetBox.master.userUID).toString()
                                }
                                break;
                            case 11:
                                self.targetBox.master.notification.type = 11
                                self.targetBox.master.notification.data = null
                                break;
                        }
                        db.collection("environments").doc(self.targetBox.master.boxIdentificationCode).set(self.targetBox.master).then(function(){
                            self.$store.commit("notification", {message:"BOXマスターを登録しました。", isError:false})
                            const register = new BoxRegister.Register()
                            register.Regist(self, self.targetBox.master)
                        }).catch (function (error){
                            self.$store.commit("notification", {message:"BOXマスターの登録に失敗しました。", isError:true})
                            self.mi_writeLog("MaintenanceBox/updatePlace", "BOXマスターの登録に失敗しました。("+error+")")
                        })
                    }
                    self.isView = false
                }).catch (function (error) {
                    self.$store.commit("notification", {message:"BOXの登録に失敗しました。", isError:true})
                    self.mi_writeLog("MaintenanceBox/updatePlace", "BOXの登録に失敗しました。("+error+")")
                })
            },
            /**
             * このダイアログを表示
             */
            show: function (targetBox) {
                this.targetBox = targetBox
                this.isView = true
                this.editItems = {
                    /** 識別コード */
                    code: null,
                    /** 名称 */
                    name: null,
                    /** 生存信号警報 */
                    aliveAlarm: {
                        enabled: false,
                        durationTime: 0,
                        nextAlarmInterval: 0
                    },
                    notification: {
                        type: 1,
                        typeTelData: {
                            callTime: 30,
                            reCallInterval: 60,
                            reNum: 5,
                            tel: null
                        }
                    }
                }
                if (this.targetBox != null) {
                    this.editItems.code = this.targetBox.box.boxIdentificationCode
                    this.editItems.name = this.targetBox.box.name
                    this.editItems.aliveAlarm.enabled = this.targetBox.master.aliveAlarm.enabled
                    this.editItems.aliveAlarm.durationTime = this.targetBox.master.aliveAlarm.durationTime
                    this.editItems.aliveAlarm.nextAlarmInterval = this.targetBox.master.aliveAlarm.nextAlarmInterval
                    this.editItems.notification.type = this.targetBox.master.notification.type
                    switch (this.targetBox.master.notification.type) {
                        case 1:
                            // 通知=TEL
                            this.editItems.notification.typeTelData.callTime = this.targetBox.master.notification.data.callTime
                            this.editItems.notification.typeTelData.reCallInterval = this.targetBox.master.notification.data.reCallInterval
                            this.editItems.notification.typeTelData.reNum = this.targetBox.master.notification.data.reNum
                            this.editItems.notification.typeTelData.tel = crypto.AES.decrypt(this.targetBox.master.notification.data.tel, this.targetBox.master.userUID).toString(crypto.enc.Utf8)
                            break
                    }
                }
            }
        }
    }
</script>


                editItems: {
                    /** 識別コード */
                    code: null,
                    /** 名称 */
                    name: null,
                    /** 生存信号警報 */
                    aliveAlarm: {
                        enabled: false,
                        durationTime: 0,
                        nextAlarmInterval: 0
                    },
                    notification: {
                        type: 1,
                        typeTelData: {
                            callTime: 30,
                            reCallInterval: 60,
                            reNum: 5
                        }
                    }
                },
